// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-content.isModal .main-col {
  width: 100%;
}

.topItemImage img {
  max-height: 600px;
  height: auto;
}

.propertyValue {
  overflow: auto;
  white-space: initial;
}

.title {
  font-size: 16px;
}

.button-size {
  width: 100%;
}

.button-box {
  text-align: center;
  padding: 5px;
}

.tabs-content {
  padding: 5px;
}
.tabs-content .tabs-header {
  padding: 0 5px;
}
.tabs-content .tabs-header ion-button {
  margin: 0 2px;
  height: 28px;
  --border-radius: 4px 4px 0 0;
  --border-color: var(--main-top);
  --border-width: 1px 1px 0 1px;
  --border-style: solid;
  --box-shadow: 0;
  --background: none;
  --color: var(--text-b);
  --background-activated: var(--main-top);
}
.tabs-content .tabs-header ion-button.active {
  --background: var(--main-top);
  --color: var(--main-top-text);
}
.tabs-content .tabs-body {
  border: 1px solid var(--main-top);
  border-radius: 4px;
  background: #fff;
  padding: 10px;
  box-shadow: 0px 2px 3px #ccc;
}

.margin {
  margin-top: 5px;
}

.props-box {
  padding: 5px 0;
}
.props-box ion-card {
  margin-top: 0;
  margin-bottom: 0;
}

.out-of-stock {
  text-align: center;
  background: #ccc;
  padding: 5px;
  font-weight: 700;
}

.favorite-box {
  font-size: 29px;
  text-align: end;
}

.favorite-box.active {
  color: var(--button-a-background);
  -webkit-text-stroke: 1px black;
}

ion-badge.sale {
  font-size: 20px;
  --background: var(--button-a-background);
  color: var(--button-a-text);
}

.amount-box {
  margin: 0 20px;
}
.amount-box ion-input {
  max-width: 70px;
  display: inline-flex;
  background: #fff;
  --padding-top: 2px;
  --padding-bottom: 2px;
}
.amount-box .input-box {
  background: #fff;
  border-radius: 5px;
  padding: 2px 5px;
  margin: 0 5px;
}
.amount-box ion-button {
  height: 30px;
  margin: 0;
  vertical-align: middle;
  font-size: 7px;
}

.whatsapp-fab {
  --background: #4CAF50;
  --color: #fff;
}

ion-fab.secondfab {
  bottom: 195px;
}

.add-to-cart-box {
  width: 100%;
}
.add-to-cart-box ion-button {
  width: inherit;
}

.amount-input {
  height: 45px;
  min-width: 20%;
  border: 1px solid #ccc;
  border-radius: 5px;
  text-align: center;
  padding: 0;
  --padding-start: 0;
}

.amount-btn {
  height: 46px;
  --border-radius: 0 !important;
  border-radius: 0 !important;
  --background: none;
  background: none;
  border: 1px solid var(--button-a-background);
  color: var(--button-a-background);
}

.rate-bar {
  font-size: 20px;
  display: flex;
  align-items: center;
  gap: 2px;
}
.rate-bar span {
  margin: 0 5px;
}

.coupon-generator ion-card-header h6 {
  margin: 0;
  font-weight: bold;
}
.coupon-generator ion-card-content {
  border-top: 1px solid #e0e0e0;
  border-top-style: dashed;
  padding-top: 10px;
}

.coupon-generator::after {
  position: absolute;
  content: "";
  height: 20px;
  right: -10px;
  border-radius: 40px;
  z-index: 1;
  top: 42px;
  background-color: #e0e0e0;
  width: 20px;
}

.coupon-generator::before {
  position: absolute;
  content: "";
  height: 20px;
  left: -10px;
  border-radius: 40px;
  z-index: 1;
  top: 42px;
  background-color: #e0e0e0;
  width: 20px;
}`, "",{"version":3,"sources":["webpack://./src/core/pages/item/item.page.scss"],"names":[],"mappings":"AACE;EACE,WAAA;AAAJ;;AAIA;EACE,iBAAA;EACA,YAAA;AADF;;AAIA;EACE,cAAA;EACA,oBAAA;AADF;;AAIA;EACE,eAAA;AADF;;AAIA;EACE,WAAA;AADF;;AAIA;EACE,kBAAA;EACA,YAAA;AADF;;AAIA;EACE,YAAA;AADF;AAGE;EACE,cAAA;AADJ;AAGI;EACE,aAAA;EACA,YAAA;EAEA,4BAAA;EACA,+BAAA;EACA,6BAAA;EACA,qBAAA;EACA,eAAA;EAGA,kBAAA;EACA,sBAAA;EAEA,uCAAA;AALN;AAQI;EACE,6BAAA;EACA,6BAAA;AANN;AAUE;EACE,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,4BAAA;AARJ;;AAYA;EACE,eAAA;AATF;;AAYA;EACE,cAAA;AATF;AAWE;EACE,aAAA;EACA,gBAAA;AATJ;;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;AAVF;;AAaA;EACE,eAAA;EACA,eAAA;AAVF;;AAaA;EACE,iCAAA;EACA,8BAAA;AAVF;;AAaA;EACE,eAAA;EACA,wCAAA;EACA,2BAAA;AAVF;;AAaA;EACE,cAAA;AAVF;AAYE;EAEE,eAAA;EACA,oBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,qBAAA;AAZJ;AAeE;EACE,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;AAbJ;AAgBE;EACE,YAAA;EACA,SAAA;EACA,sBAAA;EACA,cAAA;AAdJ;;AAwBA;EACE,qBAAA;EACA,aAAA;AArBF;;AAwBA;EACE,aAAA;AArBF;;AA+BA;EACE,WAAA;AA5BF;AA8BE;EACE,cAAA;AA5BJ;;AAgCA;EAEE,YAAA;EACA,cAAA;EACA,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,UAAA;EACA,kBAAA;AA9BF;;AAiCA;EACE,YAAA;EACA,6BAAA;EACA,2BAAA;EACA,kBAAA;EACA,gBAAA;EACA,4CAAA;EACA,iCAAA;AA9BF;;AAiCA;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,QAAA;AA9BF;AAwCE;EAEE,aAAA;AAvCJ;;AA6CI;EACE,SAAA;EACA,iBAAA;AA1CN;AA8CE;EACE,6BAAA;EACA,wBAAA;EACA,iBAAA;AA5CJ;;AAgDA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,yBAAA;EACA,WAAA;AA7CF;;AAgDA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,mBAAA;EACA,UAAA;EACA,SAAA;EACA,yBAAA;EACA,WAAA;AA7CF","sourcesContent":["ion-content.isModal{\n  .main-col{\n    width: 100%;\n  }\n}\n\n.topItemImage img {\n  max-height: 600px;\n  height: auto;\n}\n\n.propertyValue {\n  overflow: auto;\n  white-space: initial;\n}\n\n.title {\n  font-size: 16px;\n}\n\n.button-size {\n  width: 100%;\n}\n\n.button-box {\n  text-align: center;\n  padding: 5px;\n}\n\n.tabs-content {\n  padding: 5px;\n\n  .tabs-header {\n    padding: 0 5px;\n\n    ion-button {\n      margin: 0 2px;\n      height: 28px;\n\n      --border-radius: 4px 4px 0 0;\n      --border-color: var(--main-top);\n      --border-width: 1px 1px 0 1px;\n      --border-style: solid;\n      --box-shadow: 0;\n\n      //--background: var(--button-b-text);\n      --background: none;\n      --color: var(--text-b);\n\n      --background-activated: var(--main-top);\n    }\n\n    ion-button.active {\n      --background: var(--main-top);\n      --color: var(--main-top-text);\n    }\n  }\n\n  .tabs-body {\n    border: 1px solid var(--main-top);\n    border-radius: 4px;\n    background: #fff;\n    padding: 10px;\n    box-shadow: 0px 2px 3px #ccc;\n  }\n}\n\n.margin {\n  margin-top: 5px;\n}\n\n.props-box {\n  padding: 5px 0;\n\n  ion-card {\n    margin-top: 0;\n    margin-bottom: 0;\n  }\n}\n\n.out-of-stock {\n  text-align: center;\n  background: #ccc;\n  padding: 5px;\n  font-weight: 700;\n}\n\n.favorite-box {\n  font-size: 29px;\n  text-align: end;\n}\n\n.favorite-box.active {\n  color: var(--button-a-background);\n  -webkit-text-stroke: 1px black;\n}\n\nion-badge.sale {\n  font-size: 20px;\n  --background: var(--button-a-background);\n  color: var(--button-a-text);\n}\n\n.amount-box {\n  margin: 0 20px;\n\n  ion-input {\n    //max-width: 50px;\n    max-width: 70px;\n    display: inline-flex;\n    background: #fff;\n    //margin: 0 5px;\n    --padding-top: 2px;\n    --padding-bottom: 2px;\n  }\n\n  .input-box {\n    background: #fff;\n    border-radius: 5px;\n    padding: 2px 5px;\n    margin: 0 5px;\n  }\n\n  ion-button {\n    height: 30px;\n    margin: 0;\n    vertical-align: middle;\n    font-size: 7px;\n  }\n}\n\n//ion-fab {\n//  bottom: 130px;\n//\n//\n//}\n\n.whatsapp-fab {\n  --background: #4CAF50;\n  --color: #fff;\n}\n\nion-fab.secondfab {\n  bottom: 195px;\n}\n\n//.danger{\n//  color: red;\n//}\n//.primary{\n//  color: #0b3e6f;\n//}\n\n.add-to-cart-box {\n  width: 100%;\n\n  ion-button {\n    width: inherit;\n  }\n}\n\n.amount-input\n{\n  height: 45px;\n  min-width: 20%;\n  border: 1px solid #ccc;\n  border-radius: 5px;\n  text-align: center;\n  padding: 0;\n  --padding-start: 0;\n}\n\n.amount-btn{\n  height: 46px;\n  --border-radius: 0 !important;\n  border-radius: 0 !important;\n  --background: none;\n  background: none;\n  border: 1px solid var(--button-a-background);\n  color: var(--button-a-background);\n}\n\n.rate-bar{\n  font-size: 20px;\n  display: flex;\n  align-items: center;\n  gap: 2px;\n\n  ion-icon{\n    //font-size: 20px;\n  }\n\n  ion-icon:hover, ion-icon.active{\n    //color:var(--button-a-background);\n  }\n\n  span{\n    //font-size: 20px;\n    margin: 0 5px;\n  }\n}\n\n.coupon-generator{\n  ion-card-header{\n    h6 {\n      margin: 0;\n      font-weight: bold;\n    }\n  }\n\n  ion-card-content{\n    border-top: 1px solid #e0e0e0;\n    border-top-style: dashed;\n    padding-top: 10px;\n  }\n}\n\n.coupon-generator::after {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  right: -10px;\n  border-radius: 40px;\n  z-index: 1;\n  top: 42px;\n  background-color: #e0e0e0;\n  width: 20px;\n}\n\n.coupon-generator::before {\n  position: absolute;\n  content: \"\";\n  height: 20px;\n  left: -10px;\n  border-radius: 40px;\n  z-index: 1;\n  top: 42px;\n  background-color: #e0e0e0;\n  width: 20px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
